import React from "react";
import {
  Box,
  Flex,
  Image,
  InputGroup,
  InputRightElement,
  Text,
  // useDisclosure,
} from "@chakra-ui/react";
import TableStatementDetail from "./tableStatementDetail";
import DatePicker from "react-datepicker";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import { useState } from "react";
import { vi } from "date-fns/locale";

export default function StatementDetail() {
  const currentYear = new Date().getFullYear();
  const [date, setDate] = useState(null);

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }} w={"100%"} >
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Báo cáo {currentYear || 2025}
          </Text>
          <InputGroup w={"100%"} maxW={"255px"} zIndex={"4"} position={"relative"}>
            <DatePicker
              selected={date}
              onChange={(date) => setDate(date)}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              isClearable={true}
              placeholderText="Tháng năm (MM/yyyy)"
              className="datePickerStyle"
              locale={vi}
            />
            {!date && (
              <InputRightElement pointerEvents="none" h={"44px"}>
                <Image src={calendarIcon} />
              </InputRightElement>
            )}
          </InputGroup>
        </Flex>
      </Flex>
      <Box mt={{ base: "23px" }}>
        <TableStatementDetail date={date} />
      </Box>
    </Box>
  );
}
